import { BusinessCard } from "../types";

export const scanBusinessCard = async (base64Image: string): Promise<BusinessCard[]> => {
  // Extract pure base64 if it has data prefix
  const pureBase64 = base64Image.includes(',') ? base64Image.split(',')[1] : base64Image;

  try {
    const response = await fetch('/api/scan', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ base64Image: pureBase64 }),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data as BusinessCard[];
  } catch (e) {
    console.error("Scan API Error:", e);
    return [];
  }
};

export const searchPersonOrCompany = async (query: string): Promise<{ content: string; sources: any[] }> => {
  try {
    const response = await fetch('/api/search', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data as { content: string; sources: any[] };
  } catch (e) {
    console.error("Search API Error:", e);
    return {
      content: "搜尋時發生錯誤，請稍後再試。",
      sources: []
    };
  }
};
